import { hcWithType } from "@nimble/api-sample/hc";

if (!process.env.NEXT_PUBLIC_SAMPLE_API_URL) {
  throw new Error("NEXT_PUBLIC_SAMPLE_API_URL is not defined");
}

const connectApiClient = hcWithType(process.env.NEXT_PUBLIC_SAMPLE_API_URL);

export default connectApiClient;
